/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SubjectsForGroupDTO,
    SubjectsForGroupDTOFromJSON,
    SubjectsForGroupDTOFromJSONTyped,
    SubjectsForGroupDTOToJSON,
} from './SubjectsForGroupDTO';

/**
 * 
 * @export
 * @interface DisciplineSubgroupDTO
 */
export interface DisciplineSubgroupDTO {
    /**
     * 
     * @type {string}
     * @memberof DisciplineSubgroupDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DisciplineSubgroupDTO
     */
    name?: string | null;
    /**
     * 
     * @type {Array<SubjectsForGroupDTO>}
     * @memberof DisciplineSubgroupDTO
     */
    subjects?: Array<SubjectsForGroupDTO> | null;
    /**
     * 
     * @type {string}
     * @memberof DisciplineSubgroupDTO
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof DisciplineSubgroupDTO
     */
    groupName?: string | null;
}

export function DisciplineSubgroupDTOFromJSON(json: any): DisciplineSubgroupDTO {
    return DisciplineSubgroupDTOFromJSONTyped(json, false);
}

export function DisciplineSubgroupDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisciplineSubgroupDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'subjects': !exists(json, 'subjects') ? undefined : (json['subjects'] === null ? null : (json['subjects'] as Array<any>).map(SubjectsForGroupDTOFromJSON)),
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
    };
}

export function DisciplineSubgroupDTOToJSON(value?: DisciplineSubgroupDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'subjects': value.subjects === undefined ? undefined : (value.subjects === null ? null : (value.subjects as Array<any>).map(SubjectsForGroupDTOToJSON)),
        'groupId': value.groupId,
        'groupName': value.groupName,
    };
}

